import { getDB } from '../store/db';

export const PhotoStorage = {
    async savePhoto(logId, file) {
        const db = await getDB();
        const id = crypto.randomUUID();

        // Basic image compression/resizing could be added here in the future
        const photoData = {
            id,
            logId,
            blob: file, // Storing as Blob in IDB
            created_at: new Date().toISOString()
        };

        await db.put('photos', photoData);
        return id;
    },

    async getPhotoByLog(logId) {
        const db = await getDB();
        const tx = db.transaction('photos', 'readonly');
        const index = tx.store.index('by-log');
        return await index.get(logId);
    },

    async deletePhoto(photoId) {
        const db = await getDB();
        await db.delete('photos', photoId);
    }
};
